import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AlvoTab from '@/components/moduli/AlvoTab';
import DocceTab from '@/components/moduli/DocceTab';
import TurniTab from '@/components/moduli/TurniTab';
import BiancheriaTab from '@/components/moduli/BiancheriaTab';
import ChecklistTab from '@/components/moduli/ChecklistTab';
import ContattiTab from '@/components/moduli/ContattiTab';
import { ClipboardList, ShowerHead, CalendarDays, Layers, ShieldCheck, Phone } from 'lucide-react';

export default function Moduli() {
  const [area, setArea] = useState('');

  return (
    <div className="space-y-5" data-testid="moduli-page">
      <div>
        <h1 className="text-2xl font-semibold text-slate-800 font-[Cinzel]">Moduli Operativi</h1>
        <p className="text-sm text-slate-500 mt-0.5">Alvo, piano docce, turni, biancheria, carrello d'emergenza e rubrica contatti</p>
      </div>

      <Tabs defaultValue="alvo">
        <TabsList className="bg-white border border-slate-200">
          <TabsTrigger value="alvo" data-testid="tab-alvo"><ClipboardList className="w-4 h-4 mr-1.5" />Alvo</TabsTrigger>
          <TabsTrigger value="docce" data-testid="tab-docce"><ShowerHead className="w-4 h-4 mr-1.5" />Piano Docce</TabsTrigger>
          <TabsTrigger value="turni" data-testid="tab-turni"><CalendarDays className="w-4 h-4 mr-1.5" />Turni</TabsTrigger>
          <TabsTrigger value="biancheria" data-testid="tab-biancheria"><Layers className="w-4 h-4 mr-1.5" />Biancheria</TabsTrigger>
          <TabsTrigger value="emergenza" data-testid="tab-emergenza"><ShieldCheck className="w-4 h-4 mr-1.5" />Carrello Emergenza</TabsTrigger>
          <TabsTrigger value="contatti" data-testid="tab-contatti"><Phone className="w-4 h-4 mr-1.5" />Contatti</TabsTrigger>
        </TabsList>
        <TabsContent value="alvo" className="mt-4"><AlvoTab area={area} setArea={setArea} /></TabsContent>
        <TabsContent value="docce" className="mt-4"><DocceTab area={area} setArea={setArea} /></TabsContent>
        <TabsContent value="turni" className="mt-4"><TurniTab /></TabsContent>
        <TabsContent value="biancheria" className="mt-4"><BiancheriaTab /></TabsContent>
        <TabsContent value="emergenza" className="mt-4"><ChecklistTab /></TabsContent>
        <TabsContent value="contatti" className="mt-4"><ContattiTab area={area} /></TabsContent>
      </Tabs>
    </div>
  );
}
